/* HN legacy offer: one scoped, idempotent styling controller.
 * Shopify Forms retains ownership of inputs, validation, uploads and submission.
 */
(function () {
  'use strict';
  if (window.HNLegacyFormStable) { window.HNLegacyFormStable.scan(); return; }
  var selector = '.hn-offer shopify-forms-embed';
  var states = new Map();
  var retryTimer = 0;
  var attempts = 0;
  var stopped = false;
  var controlSelector = "input:not([type='hidden']):not([type='submit']):not([type='button']), textarea, select";
  var styleId = 'hn-legacy-form-stable-style';
  var css = `
    :host { color: #292724 !important; font-family: var(--font-body-family, 'Quattrocento Sans'), sans-serif !important; }
    * { box-sizing: border-box !important; }
    [data-hn-hide-title='true'] { display: none !important; }
    [data-hn-layout-ancestor='true'] { width: 100% !important; max-width: none !important; min-height: 0 !important; margin: 0 !important; padding-top: 0 !important; padding-bottom: 0 !important; }
    [data-hn-fields-grid='true'] { display: grid !important; grid-template-columns: repeat(2,minmax(0,1fr)) !important; column-gap: 24px !important; row-gap: 24px !important; align-items: end !important; width: 100% !important; max-width: none !important; margin: 0 !important; padding: 0 !important; }
    [data-hn-fields-grid='true'] > * { grid-column: 1 / -1 !important; min-width: 0 !important; margin-left: 0 !important; margin-right: 0 !important; }
    [data-hn-cell='true'] { grid-column: var(--hn-column, 1 / -1) !important; grid-row: var(--hn-row, auto) !important; min-width: 0 !important; text-align: left !important; align-self: end !important; overflow: visible !important; }
    [data-hn-control='true'] { width: 100% !important; min-height: 62px !important; margin: 0 !important; padding: 29px 0 8px !important; border: 0 !important; border-bottom: 1px solid rgba(41,39,36,.18) !important; border-radius: 0 !important; background: transparent !important; box-shadow: none !important; color: #292724 !important; font-family: var(--font-body-family, 'Quattrocento Sans'), sans-serif !important; font-size: 15px !important; line-height: 1.3 !important; text-align: left !important; }
    [data-hn-control='true']:focus { border-bottom-color: #292724 !important; }
    [data-hn-control='true']:focus-visible { outline: 1px solid #6F665E !important; outline-offset: 3px !important; }
    [data-hn-control='true'][aria-invalid='true'] { border-bottom-color: #B42318 !important; }
    label { color: #4d4843 !important; font-family: var(--font-body-family, 'Quattrocento Sans'), sans-serif !important; font-size: 9px !important; line-height: 1.15 !important; letter-spacing: .10em !important; text-transform: uppercase !important; text-align: left !important; }
    [class*='_field'], [class*='_input'], [class*='_textField'] { border-radius: 0 !important; box-shadow: none !important; }
    [data-hn-upload='true'] { width: 100% !important; min-width: 0 !important; margin-top: 2px !important; text-align: left !important; }
    [data-hn-upload-label='true'] { color: #4D4843 !important; font-family: var(--font-body-family, 'Quattrocento Sans'), sans-serif !important; font-size: 13px !important; line-height: 1.4 !important; letter-spacing: 0 !important; text-transform: none !important; }
    [data-hn-dropzone='true'] { width: 100% !important; min-height: 82px !important; margin-top: 7px !important; padding: 16px 18px !important; border: 1px solid rgba(41,39,36,.18) !important; border-radius: 0 !important; background: rgba(255,255,255,.26) !important; box-shadow: none !important; }
    [data-hn-add-file='true'] { display: inline-flex !important; align-items: center !important; justify-content: center !important; min-height: 38px !important; padding: 0 16px !important; border: 1px solid rgba(41,39,36,.24) !important; border-radius: 0 !important; background: transparent !important; box-shadow: none !important; color: #292724 !important; font-family: var(--font-body-family, 'Quattrocento Sans'), sans-serif !important; font-size: 10.5px !important; line-height: 1 !important; letter-spacing: .10em !important; text-transform: uppercase !important; }
    button[type='submit'] { display: flex !important; align-items: center !important; justify-content: center !important; width: 100% !important; min-height: 58px !important; margin: 0 !important; padding: 18px 24px !important; border: 0 !important; border-radius: 0 !important; background: #292724 !important; color: #fff !important; box-shadow: none !important; font-family: var(--font-body-family, 'Quattrocento Sans'), sans-serif !important; font-size: 11px !important; font-weight: 400 !important; line-height: 1.3 !important; letter-spacing: .18em !important; text-transform: uppercase !important; }
    button[type='submit']:disabled { opacity: .65; cursor: wait; }
    button:focus-visible, [role='button']:focus-visible, a:focus-visible { outline: 2px solid #6F665E !important; outline-offset: 3px !important; }
    [data-hn-legal-wrap='true'] { margin-top: -6px !important; }
    [data-hn-legal-wrap='true'], [data-hn-legal-wrap='true'] p, [data-hn-legal-wrap='true'] a { color: #6F665E !important; font-family: var(--font-body-family, 'Quattrocento Sans'), sans-serif !important; font-size: 11.5px !important; line-height: 1.5 !important; text-align: left !important; }
    @media (max-width: 640px) {
      [data-hn-fields-grid='true'] { grid-template-columns: 1fr !important; row-gap: 24px !important; }
      [data-hn-cell='true'] { grid-column: 1 !important; grid-row: var(--hn-mobile-row, auto) !important; }
      [data-hn-control='true'] { min-height: 60px !important; padding-top: 28px !important; font-size: 16px !important; }
    }
  `;
  function mark(el, name, value) {
    if (el && el.getAttribute(name) !== value) el.setAttribute(name, value);
  }
  function property(el, name, value) {
    if (el.style.getPropertyValue(name) !== value) el.style.setProperty(name, value);
  }
  // Only change matching text nodes. Never replace an app-owned element or its children.
  function renameText(el, pattern, replacement) {
    if (!el || el.matches('input,textarea,select')) return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue.replace(/\s+/g, ' ').trim();
      if (pattern.test(text) && text !== replacement) node.nodeValue = replacement;
    }
  }
  function fieldBlock(control, root) {
    var node = control.parentElement;
    while (node && node !== root) {
      var parent = node.parentElement;
      if (!parent || parent === root) return node;
      if (node.querySelectorAll(controlSelector).length === 1 && parent.querySelectorAll(controlSelector).length > 1) return node;
      node = parent;
    }
    return control.parentElement;
  }
  function directChild(node, parent) {
    while (node && node.parentElement && node.parentElement !== parent) node = node.parentElement;
    return node && node.parentElement === parent ? node : null;
  }
  function place(el, column, row, mobileRow) {
    mark(el, 'data-hn-cell', 'true');
    property(el, '--hn-column', String(column));
    property(el, '--hn-row', String(row));
    property(el, '--hn-mobile-row', String(mobileRow));
  }
  function decorate(root) {
    if (!root.getElementById(styleId)) {
      var style = document.createElement('style');
      style.id = styleId;
      style.textContent = css;
      root.appendChild(style);
    }
    var controls = Array.from(root.querySelectorAll(controlSelector));
    var blocks = [];
    controls.forEach(function (control) {
      if (!/^(file|checkbox|radio|hidden)$/.test(control.type || '')) mark(control, 'data-hn-control', 'true');
      var block = fieldBlock(control, root);
      if (block && blocks.indexOf(block) < 0) blocks.push(block);
    });
    if (blocks.length < 4) return; // Leave unfamiliar layouts and success states to Shopify.
    var counts = new Map();
    blocks.forEach(function (block) { var p = block.parentElement; if (p) counts.set(p, (counts.get(p) || 0) + 1); });
    var grid = null;
    var best = 0;
    counts.forEach(function (count, parent) { if (count > best) { grid = parent; best = count; } });
    if (!grid || best < 4) return;
    mark(grid, 'data-hn-fields-grid', 'true');
    var ancestor = grid;
    while (ancestor) {
      mark(ancestor, 'data-hn-layout-ancestor', 'true');
      if (ancestor.tagName === 'FORM') break;
      ancestor = ancestor.parentElement;
    }
    var gridBlocks = blocks.filter(function (b) { return b.parentElement === grid; });
    gridBlocks.forEach(function (block, index) {
      place(block, index < 4 ? (index % 2) + 1 : '1 / -1', index < 4 ? Math.floor(index / 2) + 1 : index - 1, index + 1);
    });
    root.querySelectorAll('h1,h2,h3').forEach(function (heading) {
      if (!/^claim your haus naturals offer$/i.test(heading.textContent.trim())) return;
      var node = directChild(heading, grid) || heading;
      if (node.querySelector(controlSelector + ", button[type='submit']")) node = heading;
      while (node.parentElement && node.parentElement !== grid && !node.parentElement.querySelector(controlSelector + ", button[type='submit']")) node = node.parentElement;
      mark(node, 'data-hn-hide-title', 'true');
    });
    // Renaming is idempotent, preserves required markers, and is not an observed mutation.
    root.querySelectorAll('label, [class*="_label"]').forEach(function (label) {
      if (label.querySelector(controlSelector)) return;
      renameText(label, /^which haus naturals product did you purchase\??$/i, 'Haus Naturals product');
      renameText(label, /^where did you purchase(?: it)?\??$/i, 'Purchased from');
      renameText(label, /^order reference\s*\/\s*no\.?$/i, 'Order reference / no.');
    });
    var submit = root.querySelector("button[type='submit']");
    var lastRow = Math.max(2, gridBlocks.length - 2);
    if (submit) {
      if (!submit.disabled && submit.getAttribute('aria-busy') !== 'true') renameText(submit, /^(submit my claim|claim my 50% offer)$/i, 'Claim my 50% offer');
      var submitWrap = directChild(submit, grid);
      if (submitWrap) place(submitWrap, '1 / -1', lastRow + 1, gridBlocks.length + 1);
    }
    var fileInput = root.querySelector("input[type='file']");
    if (fileInput) {
      var upload = fieldBlock(fileInput, root);
      if (upload) {
        mark(upload, 'data-hn-upload', 'true');
        upload.querySelectorAll('label, p, span, div').forEach(function (el) {
          if (el.children.length === 0 && /^upload your product photo$/i.test(el.textContent.trim())) mark(el, 'data-hn-upload-label', 'true');
        });
        var add = Array.from(upload.querySelectorAll("button,[role='button']")).find(function (el) { return /^(add file|choose photo)$/i.test(el.textContent.trim()); });
        if (add) {
          mark(add, 'data-hn-add-file', 'true');
          renameText(add, /^add file$/i, 'Choose photo');
          var drop = add.parentElement;
          while (drop && drop.parentElement && drop.parentElement !== upload) {
            if (drop.parentElement.querySelectorAll('button').length > 1) break;
            drop = drop.parentElement;
          }
          if (drop && drop !== upload) mark(drop, 'data-hn-dropzone', 'true');
        }
      }
    }
    var legalLink = Array.from(root.querySelectorAll('a')).find(function (a) { return /privacy policy|terms of service/i.test(a.textContent); });
    if (legalLink) {
      var legal = directChild(legalLink, grid);
      if (legal && !legal.querySelector("button[type='submit'],input,textarea,select")) {
        mark(legal, 'data-hn-legal-wrap', 'true');
        place(legal, '1 / -1', lastRow + 2, gridBlocks.length + 2);
      } else mark(legalLink.parentElement, 'data-hn-legal-wrap', 'true');
    }
  }
  function release(state) {
    state.observer.disconnect();
    if (state.frame) cancelAnimationFrame(state.frame);
    states.delete(state.embed);
  }
  function render(state) {
    state.frame = 0;
    if (stopped || !state.embed.isConnected || !state.embed.closest('.hn-offer')) { release(state); return; }
    // Do not observe our own styling work. Observe only app-driven structural changes.
    state.observer.disconnect();
    try { decorate(state.root); }
    catch (error) { console.warn('[HN legacy offer] Styling skipped; native form retained.', error); }
    finally { if (!stopped && state.embed.isConnected) state.observer.observe(state.root, { childList: true, subtree: true }); }
  }
  function connect(embed) {
    var root = embed.shadowRoot;
    if (!root) return false;
    if (states.has(embed)) return true;
    var state = { embed: embed, root: root, observer: null, frame: 0 };
    state.observer = new MutationObserver(function (records) {
      if (stopped || state.frame) return;
      var structural = records.some(function (record) {
        return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (node) {
          return node.nodeType === 1 && !/^(STYLE|LINK)$/.test(node.tagName);
        });
      });
      if (structural) state.frame = requestAnimationFrame(function () { render(state); });
    });
    states.set(embed, state);
    render(state);
    return true;
  }
  function scan() {
    if (stopped) return;
    if (retryTimer) { clearTimeout(retryTimer); retryTimer = 0; }
    states.forEach(function (state) { if (!state.embed.isConnected) release(state); });
    var embeds = Array.from(document.querySelectorAll(selector));
    var pending = document.querySelector('.hn-offer') && embeds.length === 0;
    embeds.forEach(function (embed) { if (!connect(embed)) pending = true; });
    if (pending && attempts++ < 80) retryTimer = setTimeout(scan, 250);
  }
  window.HNLegacyFormStable = { scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  if (window.customElements) customElements.whenDefined('shopify-forms-embed').then(scan);
  document.addEventListener('shopify:section:load', function () { attempts = 0; scan(); });
  document.addEventListener('shopify:section:unload', function () { states.forEach(function (state) { if (!state.embed.isConnected) release(state); }); });
  window.addEventListener('pagehide', function () { stopped = true; clearTimeout(retryTimer); retryTimer = 0; states.forEach(release); });
  window.addEventListener('pageshow', function (event) { if (event.persisted) { stopped = false; attempts = 0; scan(); } });
  scan();
})();
